const getSubTotal = (isUK) => {
  console.log("isUK", isUK);
  const data = JSON.parse(localStorage.getItem("ecommerceAddToCart"));
  let subTotal = 0;
  if (!isUK) {
    subTotal = data?.reduce((sum, product) => sum + product.productAmount, 0);
  } else {
    // subTotal = data?.reduce(
    //     (sum, product) => sum + product.productAmountWithTax,
    //     0
    // );
    subTotal = data?.reduce(
      (sum, product) => sum + parseFloat(product.productAmountWithTax),
      0
    );
  }
  return subTotal;
};
const getTaxTotal = () => {
  const data = JSON?.parse(localStorage.getItem("ecommerceAddToCart"));
  const taxAmount = data?.reduce((sum, product) => sum + product.taxAmount, 0);
  return taxAmount;
};
const getDiscountTotal = (isUK) => {
  const data = JSON.parse(localStorage.getItem("ecommerceAddToCart"));
  let discountPrice = 0;
if (data) {
  if (isUK) {
    // For UK: Calculate discount based on product price with VAT and discount percentage
    discountPrice = data.reduce((sum, product) => {
      const productPriceWithTax = parseFloat(product.productPriceWithTax); // Price including VAT
      console.log("roduct.productPriceWithTax", product.productPriceWithTax);
      const quantity = parseFloat(product.quantity); // Quantity of the product
      //const discountPercentage = parseFloat(product.discountPer); // Discount percentage
      const discountPercentage = parseFloat(
        product.discountPer != null ? product.discountPer : 0
      ); // Discount percentage

      // Calculate discount amount for this product
      const discountAmount = (productPriceWithTax * discountPercentage) / 100; // Discount per unit
      const totalDiscountForProduct = discountAmount * quantity; // Multiply by quantity for total discount

      return sum + totalDiscountForProduct; // Add to sum of total discount
    }, 0);
  } else {
    // If not UK, use existing logic (could be based on discountPrice)
    discountPrice = data.reduce((sum, product) => {
      const discountPriceForProduct = parseFloat(product.discountPrice); // Discount amount per unit
      const quantity = parseFloat(product.quantity); // Quantity of the product
      return sum + discountPriceForProduct * quantity; // Add product discount multiplied by quantity
    }, 0);
  }
}
  return discountPrice.toFixed(2); // Return the total discount rounded to 2 decimal places
};

const getTotalQty = () => {
  const data = JSON.parse(localStorage.getItem("ecommerceAddToCart"));
  const qty = data?.reduce(
    (sum, product) => sum + (parseInt(product.isWeighable) === 1 ? 1 : parseFloat(product.quantity)),
    0
  );
  return qty;
};

const getCartData = () => {
  return JSON.parse(localStorage.getItem("ecommerceAddToCart"));
};

const addTocart = (item) => {
  const data = JSON.parse(localStorage.getItem("ecommerceAddToCart"));
  let cartData = [];
  if (data) {
    cartData = data;
    const index = data.findIndex(function (value) {
      return (
        value.cartId === item.cartId &&
        (value?.productVariationId === undefined ||
          parseInt(value.productVariationId) ===
          parseInt(item.productVariationId)) &&
        parseInt(value.productId) === parseInt(item.productId)
      );
    });
    if (index >= 0) {
        cartData[index] = item;
    } else cartData.push(item);
  } else {
    cartData.push(item);
  }
  const storeData = JSON.stringify(cartData);
  localStorage.setItem("ecommerceAddToCart", storeData);
};

const updateCartData = (cartData) => {
  const storeData = JSON.stringify(cartData);
  localStorage.setItem("ecommerceAddToCart", storeData);
};

const calculateTotalTax = (productPrice, taxList) => {
  let totalTax = 0;

  taxList.forEach((tax) => {
    const taxRate = parseFloat(tax.tax);

    const taxAmount = (productPrice * taxRate) / 100;

    totalTax += taxAmount;
  });

  return totalTax.toFixed(2);
};

const getOrderTotal = (productPrice, taxList) => {
  let totalTax = 0;

  taxList.forEach((tax) => {
    const taxRate = parseFloat(tax.tax);

    const taxAmount = (productPrice * taxRate) / 100;

    totalTax += taxAmount;
  });

  return totalTax.toFixed(2);
};

const getOrdTotal = (subTotal, taxTotal, shipping_amount, isUk) => {
  let orderTotal = 0;

  orderTotal =
    parseFloat(subTotal) +
    parseFloat(shipping_amount || 0) -
    getDiscountTotal(isUk);

  if (!isUk) {
    orderTotal = orderTotal + parseFloat(taxTotal);
  }

  return orderTotal.toFixed(2);
};

const calculatePriceByCountry = (order, isUK) => {
  let productPriceOriginal = 0;
  let totalProductAmount = 0;
  let quantity = parseFloat(order.quantity);
  if (isUK) {
    //productPriceOriginal = ((parseFloat(order.productPrice) + parseFloat(order.taxAmount)) - parseFloat(order.discountAmount));
    // productPriceOriginal = parseFloat(order.productPrice) + parseFloat(order.tax);
    productPriceOriginal = (parseFloat(order.productPrice) + parseFloat(order.tax));
    totalProductAmount = (parseFloat(productPriceOriginal) )* quantity;
    //console.log('hhhhhhhhhhhhhhhhh',totalProductAmount)
    return { productPriceOriginal, totalProductAmount };
  } else {
    productPriceOriginal = parseFloat(order.productPrice);
    totalProductAmount = parseFloat(order.productPrice) * quantity;

    return { productPriceOriginal, totalProductAmount };
  }
};

export default {
  getSubTotal,
  getTaxTotal,
  getDiscountTotal,
  getTotalQty,
  addTocart,
  getCartData,
  updateCartData,
  calculateTotalTax,
  getOrderTotal,
  getOrdTotal,
  calculatePriceByCountry,
};
export {
  getSubTotal,
  getTaxTotal,
  getDiscountTotal,
  getTotalQty,
  addTocart,
  getCartData,
  updateCartData,
  calculateTotalTax,
  getOrderTotal,
  getOrdTotal,
  calculatePriceByCountry,
};
